module.exports = __webpack_public_path__ + "img/logo-reverse.a2140049.svg";